// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'document-doc';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.438 15.905a1.063 1.063 0 0 1-1.063 1.062H2.625a1.063 1.063 0 0 1-1.062-1.062V2.092A1.062 1.062 0 0 1 2.625 1.03H13.25c.277 0 .543.109.742.302l2.125 2.042a1.062 1.062 0 0 1 .32.76zM6.875 8.467v-4.25' />
    <path d='M4.75 5.28V4.217H9V5.28m2.656 2.125h1.594m-1.594-3.188h1.594m-8.5 6.375h8.5m-8.5 3.188h8.5M5.813 8.467h2.125' />
  </g>
);

export const viewBox = '0 0 18 18';
